import Grid from '@mui/material/Grid';
import FormSelect from '../Form/FormSelect';
import FormTextField from '../Form/FormTextField';
import options from '../Config/options';
import Pod from '../Shared/Pod';

const JobRecordRowParameter = props => {
    return (
        <Pod
            icon={null}
            delete={() => props.handler({ target: { name: "delete" } })}
            fullWidth
        >
            <Grid container >
                <Grid item xs={3}>
                    <FormSelect
                        name='field'
                        value={props.field || ''}
                        options={props.params || []}
                        disabled={props.disabled}
                        disableUnderline
                        handler={props.handler}
                    />
                </Grid>
                <Grid item xs={1}>
                    <FormSelect
                        name='operator'
                        value={props.operator || ''}
                        options={options.operator}
                        disabled={props.disabled}
                        disableUnderline
                        handler={props.handler}
                    />
                </Grid>
                <Grid item xs>
                    <FormTextField
                        name='value'
                        value={props.value || ''}
                        disabled={props.disabled}
                        disableUnderline
                        handler={props.handler}
                    />
                </Grid>
            </Grid>
        </Pod>
    )
}
export default JobRecordRowParameter;